const PLAN_RANK = { free: 0, plus: 1, pro: 2, max: 3, ultra: 4 };
export function getPlanIdentity(plan) {
  const code = String(plan?.metadata?.planCode || plan?.metadata?.plan_code || plan?.planKey || '').toLowerCase();
  if (Object.hasOwn(PLAN_RANK, code)) return code;
  const name = String(plan?.name || plan?.planName || '').toLowerCase();
  return Object.keys(PLAN_RANK).find((key) => new RegExp(`\\b${key}\\b`).test(name)) || null;
}
export function getPlanRank(plan) {
  const key = getPlanIdentity(plan);
  return key ? PLAN_RANK[key] : Number(plan?.tier || 0);
}
